export const seasonsPathPatterns = {
  list: "/customers/:customerId/organizations/:organizationId/:sport/seasons",
} as const;
